import { actionCreators as documentEditorActionCreators } from "Areas/Documents/documentEditorPanel";
import documentsActionCreators from "Areas/Documents/redux/actionCreators";
import documentRoutingKeys from "Areas/Documents/routingKeys";
import { actionCreators as documentsSidebarMenuActionCreators } from "Areas/Sidebar/Documents";
import { Permissions, security } from "Common/permissions";
import { routesAndPagesMap } from "Common/routingUtils";
import { connect } from "react-redux";
import DocumentWithPreviewImage from "./documentWithPreviewImage";
const getProjectDocumentsHref = (projectId) => routesAndPagesMap.getPath(documentRoutingKeys.DOCUMENTS, projectId);
const canOpen = (_, projectId) => Boolean(getProjectDocumentsHref(projectId));
const canEdit = security.isAllowed([Permissions.DocumentsEdit]);
const canDelete = security.isAllowed([Permissions.DocumentsDelete]);
const canViewProjects = security.isAllowed([Permissions.ProjectsView]);
const mapStateToProps = () => ({
    canOpen,
    canEdit,
    canDelete,
    canViewProjects
});
const mapDispatchToProps = (dispatch) => ({
    onOpen: (documentId, projectId) => {
        const href = getProjectDocumentsHref(projectId);
        if (href) {
            dispatch(documentsSidebarMenuActionCreators.setDocumentSelected(documentId, true));
            window.location.href = href;
        }
    },
    onOpenEditorPanel: (documentId) => dispatch(documentEditorActionCreators.setEditDocument(documentId)),
    onOpenDuplicatePanel: (documentId) => dispatch(documentEditorActionCreators.setDuplicateDocument(documentId)),
    onDelete: (documentId, projectId) => dispatch(documentsActionCreators.deleteDocument(documentId, projectId))
});
export default connect(mapStateToProps, mapDispatchToProps)(DocumentWithPreviewImage);
